<template>
  <div>
    <headerNav title="我的邀请码" />
    <div style="text-align: center;margin-top:50px">
    <img v-if="imgdata" id="qrcode" style="width:276px;height:auto;" :src="$baseurl+imgdata"/>
    </div>
    <van-loading v-if="!imgdata" style="text-align:center" size="24px">加载中...</van-loading>
    <div style="text-align:center;margin-top:30px">
      <van-tag plain :text-color="$abctheme.basecolor" size="large" round style="margin:0 auto">长按发送二维码或截图发给朋友吧。</van-tag>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
  components: { QRCode },
  data() {
    return {
      imgdata:''
    }
  },
  created() {
    this.$nextTick(function () {
      this.qrcode();
    });
  },
  methods: {
    qrcode() {
      let that = this;
      let levelid = this.$route.query.levelId;
      const registMethod = this.$route.query.registMethod;
      console.log("levelid", this.$route);
      var text= "http://" +location.host +"/#/inviteregist?dguid=" +that.abp.userInfo.dGuid +"&registMethod=" +registMethod;
      if(levelid)
      {
        text+="&levelid=" +levelid;
      }
      console.log(text)
      this.ajax.post('/api/services/app/PhoneUser/MyRefInviteImg?url='+encodeURIComponent(text)).then(x=>{
this.imgdata=x.result;
      })
      // let qrcode = new QRCode("qrcode", {
      //   width: 300,
      //   height: 300, // 高度
      //   text:text, // 二维码内容
      //   // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
      //   // background: '#f0f',   // 背景色
      //   // foreground: '#ff0'    // 前景色
      // });
    },
  },
};
</script>